__turbopack_context__.v({
  "container": "Selfie-module-scss-module__6zhcVW__container",
  "imageContainer": "Selfie-module-scss-module__6zhcVW__imageContainer",
  "imagePlaceholderContainer": "Selfie-module-scss-module__6zhcVW__imagePlaceholderContainer",
});
